import Vue from 'vue'
import commonApi from '@/services/commonApi'
import tjCookie from '@/utils/tjCookie'
import { getPlatform } from '@tujia/fe-lib-common/lib/tj-utils/platform'
import { initPageCommonHandle } from '@common-libs/tj-common-libs/page-handle'
import { elongLogin, elongGoBackToHomePage } from '@/utils/elong.js'
import { channelTypes } from '@common-libs/tj-channel'
import { queryString } from '@common-libs/utils/url-helper'
import { initUinfo } from '@/utils/q_sniff'

export default {
  // 初始化页面加载
  init({ state, commit, getters }) {
    // 全局 Hook 处理
    return new Promise(async(resolve, reject) => {
      // check channel login
      if (getPlatform().isMpEnv && queryString('tjchannelid') === channelTypes.ELONG) {
        const result = await elongLogin()
        if (result && !result.isSuccess) {
          await Vue.prototype.$dialog({
            title: '登陆异常',
            message: result.errorMsg,
            showCancelButton: false
          })
          elongGoBackToHomePage()
          return resolve()
        } else {
          await initPageCommonHandle()
          await checkLoginAndCommonConfig({ commit })
          resolve()
        }
      } else if (process.env.VUE_APP_LOCAL === 'Q') {
        await initUinfo()
        resolve()
      } else {
        await initPageCommonHandle()
        await checkLoginAndCommonConfig({ commit })
        resolve()
      }
    })
  }
}

/**
 * userInfo & commonConfig
 * @param {*} param0
 */
async function checkLoginAndCommonConfig({ commit }) {
  // 优先重置全局store 登录状态
  // Q端bnb.qunar.com域名下无接口，不请求
  if (process.env.VUE_APP_LOCAL === 'Q') { return }
  tjCookie.setCookieByDomain('_visitor_flag', '', 365)
  const { isSuccess, data = {} } = await commonApi.getCommonConfig({ channelCode: tjCookie.getTujiaCode() })
  if (isSuccess && data.userInfo) {
    commit('setUserInfo', {
      userId: data.userInfo.userId,
      userName: data.userInfo.loginName,
      userToken: data.userInfo.loginToken,
      mobile: data.userInfo.mobile,
      customerLevel: data.userInfo.customerLevel,
      userNickName: data.userInfo.name,
      zmCredit: data.userInfo.zmCredit,
      jdCredit: data.userInfo.jdCredit,
      jdCreditBinding: data.userInfo.jdCreditBinding,
      zmCreditBinding: data.userInfo.zmCreditBinding,
      oldUser: data.userInfo.oldUser
    })
  } else {
    tjCookie.setUserId('0')
    tjCookie.setUserToken('00000000-0000-0000-0000-000000000000')
    window._fas && window._fas.setUserId('')
    tjCookie.setCookieByDomain('_visitor_flag', 'visitor000000', 365)
  }
}
